import React from "react";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import i18n from "../../../../i18n/i18n";
import RouteForm from "../routeForm/routeForm";

export default class AddRoute extends React.Component {
    render() {
        return (
            <AddItem
                class="add-route"
                header={i18n.t("topology.routes.actions.addRoute.header")}
                content={<RouteForm isUpdate={false}/>}
            />
        );
    }
}